
export abstract class ModConstants {
   
    static ALERT_API_CONTEXT = "icealert-nxi-services/";
   
}
